"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Separator = void 0;
const react_1 = __importDefault(require("react"));
exports.Separator = (props) => {
    const { name, } = props;
    return (react_1.default.createElement("div", { className: 'separator' },
        react_1.default.createElement("span", null,
            " ",
            name,
            " ")));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VwYXJhdG9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2xheW91dC9TZXBhcmF0b3IudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGtEQUFpRDtBQU1wQyxRQUFBLFNBQVMsR0FBNkIsQ0FBQyxLQUFZLEVBQUUsRUFBRTtJQUNoRSxNQUFNLEVBQ0YsSUFBSSxHQUNQLEdBQUcsS0FBSyxDQUFDO0lBRVYsT0FBTyxDQUNILHVDQUFLLFNBQVMsRUFBRyxXQUFXO1FBQ3hCOztZQUFTLElBQUk7Z0JBQVUsQ0FDckIsQ0FDVCxDQUFDO0FBQ04sQ0FBQyxDQUFDIn0=